<template>
  <div :id="chartId || id" class="bar-graph-wrapper" />
</template>

<script lang="ts">
import Component from 'vue-class-component'

import C3ChartMixin from '@/mixins/C3ChartMixin'

const props = {
  bar: {
    type: Object,
    default: null,
  },
}

@Component
export default class BarGraph extends C3ChartMixin.extend({ props }) {
  c3data: any
  c3axis: any
  c3legend: any
  c3tooltip: any

  id = 'c3-bar-graph'

  get c3config() {
    return {
      bindto: `#${this.chartId || this.id}`,
      data: { ...this.c3data, type: 'bar' },
      axis: this.c3axis,
      legend: this.c3legend,
      tooltip: this.c3tooltip,
      bar: this.bar,
    }
  }
}
</script>

<style lang="scss">
.bar-graph-wrapper {
  .c3-tooltip-container {
    .c3-tooltip {
      th {
        background-color: #455;
        font-weight: 600;
      }
      td {
        border-left: none;
      }
    }
  }
}
</style>
